import { SaveOutlined } from "@ant-design/icons";
import { App, Button, Card, Form, Space } from "antd";
import { useEffect, useState } from "react";
import { apiClient } from "../../api/apiClient";
import { PageHeaderActions } from "../../shared/components/PageHeaderActions";
import { SmartLookupField } from "../../shared/lookup/SmartLookupField";
import { getApiErrorMessage } from "../../shared/utils/apiError";

export function TaxSetupPage() {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient.get("/org-tax-setup").then(({ data }) => form.setFieldsValue(data?.data ?? data ?? {}));
  }, [form]);

  const save = async (values: Record<string, unknown>) => {
    setSaving(true);
    try {
      await apiClient.put("/org-tax-setup", values);
      message.success("Tax setup saved");
    } catch (err) {
      message.error(getApiErrorMessage(err, "Unable to save tax setup"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <PageHeaderActions title="Tax Ledger Setup" subtitle="Company tax ledgers used by invoice posting and reports." />
      <Card>
        <Form form={form} layout="vertical" onFinish={save}>
          <div className="two-column-form">
            {[
              ["cgstLedgerId", "CGST Ledger"],
              ["sgstLedgerId", "SGST Ledger"],
              ["igstLedgerId", "IGST Ledger"],
              ["tdsLedgerId", "TDS Ledger"]
            ].map(([name, label]) => (
              <Form.Item key={name} name={name} label={label} rules={[{ required: true }]}>
                <SmartLookupField lookupKey="accountLedger" onChange={(v) => form.setFieldValue(name, v.id)} />
              </Form.Item>
            ))}
          </div>
          <Space>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={saving}>Save</Button>
          </Space>
        </Form>
      </Card>
    </div>
  );
}
